export const updateModellPforte = ev => {
    return {
        type: 'UPDATEMODELLPFORTE',
        ev: ev
    }
}

export const updateMustePforte = ev => {
    return {
        type: 'UPDATEMUSTERPFORTE',
        ev: ev
    }
}

export const updateTabIndexPforte = ev => {
    return {
        type: 'UPDATETABINDEXPFORTE',
        ev: ev
    }
}

export const updateStepsPforte = ev => {
    return {
        type: 'UPDATESTEPSPFORTE',
        ev: ev
    }
}

export const updateAllVisitedStepsPforte = () => {
    return {
        type: 'UPDATEALLVISITEDSTEPSPFORTE'
    }
}

export const updadteHeightPforte = ev => {
    return {
        type: 'UPDATEHEIGHTPFORTE',
        ev: ev
    }
}

export const updateWidthPforte = ev => {
    return {
        type: 'UPDATEWIDTHPFORTE',
        ev: ev
    }
}

export const updateFormPforte = ev => {
    return {
        type: 'UPDATEFORMPFORTE',
        ev: ev
    }
}

export const dimensionKindPforte = ev => {
    return {
        type: 'DIMENSIONKINDPFORTEN',
        ev: ev
    }
}

export const selectKindOfColorPforte = ev => {
    return {
        type: 'SELECTKINDOFCOLORPFORTE',
        ev: ev
    }
}

export const selectColorPforte = ev => {
    return {
        type: 'SELECTCOLOROFPFORTE',
        ev: ev
    }
}

export const selectWishColorPforte = ev => {
    return {
        type: 'SELECTWISHCOLORPFORTE',
        ev: ev
    }
}

export const updatePfortespitzen = ev => {
    return {
        type: 'UPDATEZAUNSPITZENPFORTE',
        ev: ev
    }
}

export const updatePfostenPforte = ev => {
    return {
        type: 'UPDATEPFOSTENPFORTE',
        ev: ev
    }
}

export const updateKappenPforte = ev => {
    return {
        type: 'UPDATEKAPPENPFORTE',
        ev: ev
    }
}

export const updateDirectionPforte = ev => {
    return {
        type: 'UPDATEDIRECTIONPFORTE',
        ev: ev
    }
}

export const updateProductToMerklistePforte = () => {
    return {
        type: 'UPDATEPRODUCTTOMERKLISTEPFORTE'
    }
}

export const updateDescriptionPforte = ev => {
    return {
        type: 'UPDATEDESCRIPTIONPFORTE',
        ev: ev
    }
}

export const selectUploadDataPforte = ev => {
    return {
        type: 'SELECTUPLOADDATAPFORTE',
        ev: ev
    }
}

export const updateEditPforte = () => {
    return {
        type: 'UPDATEEDITPFORTE'
    }
}

